export const SPRINGBOARD_CATEGORIES_QUERY_KEYS = {
  categories: (workspaceId: string) => ['springboard-categories', workspaceId] as const,
} as const;
